import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import NotFound from "../NotFound/NotFound";
import {
  get_slider,
  get_image,
  parse_book_URL,
  get_course_URL,
  get_book_URL,
} from "../../helper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import api from "../../axios";
import { FaTiktok, FaWhatsapp } from "react-icons/fa";
import { CiMail } from "react-icons/ci";
import { AiOutlineClose, AiFillYoutube, AiFillFacebook } from "react-icons/ai";
import { IoMdAlbums } from "react-icons/io";
import { BsInstagram, BsLinkedin } from "react-icons/bs";
import logo from "../../assets/logo.png";

const phoneNumber = "+201027097226";
const whatsappURL = `https://wa.me/${phoneNumber}`;

const Collaborators = () => {
  const [collab, setCollab] = useState({});
  const [notFound, setNotFound] = useState(false);
  const [cards, setCards] = useState([]);
  const [covers, setCovers] = useState([]);
  const [setting, setSetting] = useState({});
  const [courses, setCourses] = useState([]);
  const [books, setBooks] = useState([]);
  const [popupImages, setPopupImages] = useState([]);
  const [sliderIndex, setSliderIndex] = useState(0);
  const [isSliderPopupOpen, setIsSliderPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);

  const { id } = useParams();
  const collabID = parse_book_URL(id);

  useEffect(() => {
    const fetchBook = async () => {
      const startTime = Date.now();

      try {
        const response = await api.get(
          `https://api.sae-grad.com/api/collaborators/${collabID}`,
          { params: { populate: "*" } }
        );
        setCollab(response.data.data);
        setCovers(response?.data?.data?.attributes?.sliders?.data || []);

        // باقي الـ APIs
        const [settingRes, coursesRes, booksRes] = await Promise.all([
          api.get("/setting", { params: { populate: "*" } }),
          api.get("/courses"),
          api.get("/play-books"),
        ]);

        setSetting(settingRes.data.data.attributes);
        setCourses(coursesRes.data.data);
        setBooks(booksRes.data.data);

        const elapsed = Date.now() - startTime;
        const remaining = Math.max(5500 - elapsed, 0);

        // 🖼️ انتظار الصور
        const waitForImages = () =>
          new Promise((resolve) => {
            const images = Array.from(document.images);
            let loadedCount = 0;

            if (images.length === 0) return resolve();

            images.forEach((img) => {
              if (img.complete) {
                loadedCount++;
                if (loadedCount === images.length) resolve();
              } else {
                img.addEventListener("load", () => {
                  loadedCount++;
                  if (loadedCount === images.length) resolve();
                });
                img.addEventListener("error", () => {
                  loadedCount++;
                  if (loadedCount === images.length) resolve();
                });
              }
            });
          });

        setTimeout(async () => {
          await waitForImages();
          setIsLoading(false);
          setFirstLoad(false);
        }, remaining);
      } catch (error) {
        console.error("Error fetching data:", error);
        setNotFound(true);
        setIsLoading(false);
        setFirstLoad(false);
      }
    };

    fetchBook();
  }, [collabID]);

  if (notFound) return <NotFound />;

  if (isLoading) {
    return (
      <div className="loader-container">
        <img className="loader-image" src={logo} alt="Loading..." />
      </div>
    );
  }

  const handleImageClick = (images, index) => {
    setPopupImages(images?.data || []);
    setSliderIndex(index);
    setIsSliderPopupOpen(true);
  };

  // Check Arabic text
  const isArabic = (text) => /[\u0600-\u06FF]/.test(text);

  const description = collab?.attributes?.description || "";
  const direction = isArabic(description) ? "rtl" : "ltr";

  return (
    <>
      <section className="interior">
        <div className="intro-image">
          <Swiper
            navigation={true}
            modules={[Navigation, Autoplay, Pagination]}
            className="mySwiper"
            autoplay={{ delay: 2000 }}
            pagination={{ clickable: true }}
            effect="coverflow"
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
          >
            {covers.map((cover, index) => (
              <SwiperSlide key={index}>
                <div className="intro-image-container">
                  <img
                    className="animated-coverflow"
                    loading={firstLoad ? "eager" : "lazy"}
                    src={get_slider(cover)}
                    alt={`cover ${index + 1}`}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="section-container">
          <div className="instructors" id="urban-mobile">
            <div className="instructor-card">
              <div className="image">
                <img
                  src={get_image(collab.attributes.home_image)}
                  alt={collab.title}
                  loading={firstLoad ? "eager" : "lazy"}
                />
              </div>
              <div className="instructor-info">
                <h4>{collab?.attributes?.title}</h4>
                <p style={{ direction }}>{collab?.attributes?.description}</p>
              </div>
            </div>
          </div>
          {cards.length > 0 && (
            <div className="Gallery">
              <div className="text">
                <h2>Gallery</h2>
              </div>
              <div className="gallery">
                <div className="gallery-container">
                  {cards.map((card, index) => (
                    <div
                      className="gallery-card"
                      key={index}
                      onClick={() => handleImageClick(card.images, index)}
                    >
                      <div className="image">
                        <img src={get_image(card.image)} alt="gallery" />
                        <div>
                          <IoMdAlbums className="album" />
                        </div>
                      </div>
                      <div className="card-text">
                        <div className="heading">
                          <h1>{card.name}</h1>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {isSliderPopupOpen && (
                  <div className="slider-popup">
                    <div className="slider-popup-content">
                      <div
                        className="slider-close-icon"
                        onClick={() => setIsSliderPopupOpen(false)}
                      >
                        <AiOutlineClose />
                      </div>
                      <Swiper
                        navigation={true}
                        modules={[Navigation, Pagination]}
                        initialSlide={sliderIndex}
                        className="slider-popup-swiper"
                        pagination={{ clickable: true }}
                      >
                        {popupImages.map((image, index) => (
                          <SwiperSlide key={index}>
                            <div className="slider-popup-image">
                              <img src={get_slider(image)} alt="popup" />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="footer">
            <div className="social">
              <h3>Contact Us</h3>
              <div className="social2">
                <div>
                  <a
                    href={whatsappURL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp /> {phoneNumber}
                  </a>
                  <a
                    href={setting?.facebook_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <AiFillFacebook className="icon" /> Facebook
                  </a>
                  <a
                    href={setting?.instagram_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <BsInstagram className="icon" /> Instagram
                  </a>
                  <a
                    href="mailto:info@sae-grad.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <CiMail className="icon" /> Mail
                  </a>
                </div>
                <div>
                  <a
                    href={setting?.tiktok_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaTiktok className="icon" /> TikTok
                  </a>
                  <a
                    href={setting?.linkedin_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <BsLinkedin className="icon" /> LinkedIn
                  </a>
                  <a
                    href={setting?.youtube_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <AiFillYoutube className="icon" /> Youtube
                  </a>
                </div>
              </div>
            </div>

            <div className="course">
              <h3>Other Programs</h3>
              {[...courses]
                .sort((a, b) => a.attributes.rank - b.attributes.rank) // تصاعدي
                .map((course) => (
                  <Link
                    key={course.id}
                    to={`/courses/${get_course_URL(course)}`}
                  >
                    {course?.attributes?.title}
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Collaborators;
